import axiosInstance from '../mainService';
const complaintService = {
    getComplaint(search, page, title) {
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstance.get(`/data/t109_complaints/subject/${sanitizedSearch}/${page}/${title}`).then(response => {
            return {
                data: response.data,
                headers: response.headers, // Total data dari header
            };
        });
    },
    totalAllComplaint(search){
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstance.get(`/count-data/t109_complaints/subject/${sanitizedSearch}`);
    },
    addComplaint(data) {
        return axiosInstance.post('/upload-data-complaint', data);        
    },
    updateComplaint(data) {
        return axiosInstance.put(`/update-data/t109_complaints/${data.id}`, data);
    },
    deleteComplaint(id, bukti) {
        return axiosInstance.delete(`/delete-data/t109_complaints/${id}/${bukti}`);
    },
    downloadComplaintList(){
        return axiosInstance.get('/download-data-complaint');
    }
}

export default complaintService;